import Card from '../card'
import { REQUIRED, MAX } from '@/validation-types'

export default {
  data() {
    return {
      REQUIRED,
      MAX,
    }
  },
  props: {
    deal: { required: true },
  },
  extends: Card,
}
